import { defineMessages } from 'react-intl'

export default defineMessages({
  trialEnding: {
    id: 'dashboard.TrialEnding.title',
    defaultMessage: 'Free usage is about to run out.'
  },
  trialEndingDescription: {
    id: 'dashboard.TrialEnding.description',
    defaultMessage:
      'You have {remaining} visits and follow-ups remaining this month. Contact us if you need more access.'
  },
  contactUs: {
    id: 'dashboard.TrialEnding.contactUs',
    defaultMessage: 'Contact Us'
  }
})
